import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
export const DEFAULT_ALERT_TYPES = ["FAILED", "UNACKED", "MULTIPLE_MATCHED"];
export const emptyTableResponse = () => ({
  result: 0,
  retVal: {
    datas: [],
    totalRows: 0,
    firstResult: 0,
    pageSize: 20
  }
});
export const systemName = system => {
  const names = {
    UC: $t("gg1kuv7", "UC 用户中心"),
    IHOTEL: "iHotel PMS",
    ICATER: $t("c7ivmxb", "iCater 餐饮管理")
  };
  return names[system] || system || "—";
};
export const formatTime = value => {
  if (!value) return "—";
  return String(value).replace("T", " ").slice(0, 19);
};
export const tableFirstResult = search => {
  var _ref, _search$firstResult;
  return (_ref = (_search$firstResult = search.firstResult) !== null && _search$firstResult !== void 0 ? _search$firstResult : search.current) !== null && _ref !== void 0 ? _ref : 0;
};
export const selectedSystems = value => {
  return value && value !== "ALL" ? [value] : undefined;
};
export const joinNames = value => {
  if (Array.isArray(value)) {
    return value.map(item => typeof item === "string" ? item : item.name).filter(Boolean).join("、") || "—";
  }
  return value || "—";
};
export const highestPriorityAccount = (accounts = []) => {
  return accounts.find(item => item.latestUnacked) || accounts.find(item => !item.bound || item.lastResult === "FAILED") || accounts.find(item => item.lastResult === "SUCCESS") || accounts[0] || null;
};